(function (skyward, $, undefined)
{
    "use strict";

    skyward.iconifiedinputs = skyward.iconifiedinputs || {};
    skyward.iconifiedinputs.iconify = initIconifiedInputs;

    skyward.window.registerLoadDOMCallback(function (_selector)
    {
        initIconifiedInputs(this);
    });

    function initIconifiedInputs(element)
    {
        // Find stubbed <input.iconified> and corresponding svgs, wrap them with a button if necessary, and create backing-data and bindings
        $(element).find("input.iconifyme").each(function ()
        {
            var input = $(this);
            var icons = input.next("svg").next("svg").addBack();
            icons = icons.length ? icons : input.next("span").find("svg").next("svg").addBack();

            //Only iconify the input if we found a valid icon
            if (!icons.length)
            {
                return;
            }

            input.hide();

            // Inputs not rendered via viewpart CheckboxButton (i.e. Checkbox) will need to be wrapped in an anchor.
            var button = input.parent('.button.iconifyme');
            if (!button.length)
            {
                var rawButton = document.createElement("a");
                var classes = "button svgAnchor" + (icons.length === 2 ? " dual-icon" : "");
                rawButton.setAttribute("class", classes);
                rawButton.href = "javascript:void(0);";
                rawButton.setAttribute("aria-label", getRelatedLabelText(input));
                rawButton.tabIndex = input[0].tabIndex;
                button = $(rawButton);
                button.insertBefore(input);
                button.append([input, icons]);
            }

            input.removeClass("iconifyme").addClass("iconified");
            button.addClass("iconified-button")
                .toggleClass("checked", input.is(":checked"))
                .on("click", null, { input: input }, buttonClicked);
            
            if (input.hasClass("change-fill-color"))
            {
                input.removeClass("change-fill-color");
                button.addClass("change-fill-color");
            }

            var clickAction = input.attr("data-click-action");
            if (clickAction !== undefined)
            {
                input.removeAttr("data-click-action");
                button.attr("data-click-action", clickAction);
            }

            if (input.is(":disabled"))
            {
                button.addClass("ui-disabled");
                button.prop("tabindex", "-1");
            }

            input.on("change deselect jschange", null, { button: button, name: input.attr("name") }, inputChanged);
        });
    }

    // Pass button clicks to hidden input element
    function buttonClicked(event)
    {
        var input = event.data.input;
        if (input.is(":disabled"))
        {
            return;
        }

        if (input.is(":checked"))
        {
            // Cannot uncheck a checked radio by clicking it - must click another member of the RadioSet
            if (input.is("[type='checkbox']"))
            {
                input.prop("checked", false);
                // Here we have to manually trigger 'change' to simulate a "non-programmatic change"
                input.trigger("change");
            }
        }
        else
        {
            input.prop("checked", true);
            input.trigger("change");
        }
    }

    // Update button state, .checked or :not(.checked), when input changes
    // If a radio has just been checked, trigger "deselect" on related radios
    function inputChanged(event)
    {
        var input = $(this);
        if (input.is(":checked"))
        {
            event.data.button.addClass("checked");
            if (input.is("[type='radio']"))
            {
                $('input[name="' + event.data.name + '"]').not(input).trigger('deselect');
            }
        }
        else
        {
            event.data.button.removeClass("checked");
        }
    }

    function getRelatedLabelText(input)
    {
        // Find label text (for anchor alt-text, ADA compliance)
        var labelText = '';
        var controlId = input.attr("id");
        if (controlId)
        {
            var relatedLabel = input.siblings("label[for=" + controlId + "]");
            if (relatedLabel.length)
            {
                labelText = relatedLabel.text();
            }
        }
        return labelText;
    }

}(window.skyward = window.skyward || {}, window.jQuery));
